import { useEffect, useState } from "react";

interface ValidationRule {
	type: string;
	[key: string]: any;
}

export function useValidationRules(validationRules?: ValidationRule[]) {
	const [isRequired, setIsRequired] = useState(false);

	useEffect(() => {
		if (validationRules && Array.isArray(validationRules)) {
			const hasRequiredRule = validationRules.some(
				(rule) => rule.type === "required",
			);
			setIsRequired(hasRequiredRule);
		} else {
			setIsRequired(false);
		}
	}, [validationRules]);

	return { isRequired };
}
